import React from "react";
import { Box, Button, Container, Divider, Stack, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useNavigate } from "react-router-dom";
import logo from "../images/LogoNavbar1.svg";

const WHATSAPP_URL = "https://wa.me/message/HOYXZTTFNXNZH1";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <Box component="footer" sx={{ bgcolor: "#19242F", color: "#fff", pt: { xs: 4, sm: 6, md: 8 }, pb: { xs: 2.5, md: 3 } }}>
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: 520 }}>
          <Stack direction="row" alignItems="center" spacing={1.2}>
            <Box component="img" src={logo} alt="WebProfit" sx={{ width: { xs: 40, sm: 46 }, height: { xs: 40, sm: 46 } }} />
            <Typography sx={{ fontWeight: 950, fontSize: "1.55rem", letterSpacing: "-.035em" }}>WebProfit</Typography>
          </Stack>
          <Typography sx={{ mt: 1, color: "rgba(255,255,255,.6)", lineHeight: 1.5, fontSize: { xs: ".88rem", sm: "1rem" } }}>
            Curso rápido, recursos y soporte de WebProfit.
          </Typography>
        </Box>

        <Divider sx={{ my: { xs: 2.5, sm: 4 }, borderColor: "rgba(255,255,255,.1)" }} />

        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} spacing={3}>
          <Stack direction="row" useFlexGap flexWrap="wrap" spacing={{ xs: .35, sm: 2.5 }}>
            <Button onClick={() => navigate("/")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start", minHeight: { xs: 34, sm: 36 }, px: { xs: .8, sm: 1 } }}>Inicio</Button>
            <Button onClick={() => navigate("/servicios")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start", minHeight: { xs: 34, sm: 36 }, px: { xs: .8, sm: 1 } }}>Planes</Button>
            <Button onClick={() => navigate("/documentacion")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start", minHeight: { xs: 34, sm: 36 }, px: { xs: .8, sm: 1 } }}>Curso rápido</Button>
            <Button onClick={() => (window.location.href = WHATSAPP_URL)} startIcon={<WhatsAppIcon />} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start", minHeight: { xs: 34, sm: 36 }, px: { xs: .8, sm: 1 } }}>Soporte por WhatsApp</Button>
          </Stack>
          <Typography sx={{ color: "rgba(255,255,255,.42)", fontSize: ".82rem" }}>
            © {new Date().getFullYear()} WebProfit. Todos los derechos reservados.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
